<template>
  <div>
    <!-- 选择项目 -->
    <StepThreeCombat @clickCombat="clickCombat"></StepThreeCombat>
    <!-- 选择备选队员 -->
    <a-spin :spinning="playerLoading">
      <StepThreeAlternativePlayer
        :playerData="playerData"
        @ok="stepThreeAlternativePlayerOk"
        @addPlayerSuccess="queryAgencyPlayerByAge"
        v-show="stepThreeAlternativePlayerShow"/>
      <!-- 选择参赛项目 -->
      <StepThreeJoinCombatDetail
        ref="stepThreeJoinCombatDetail"
        :combatDetailGroup="combatDetailGroup"
        :choicedPlayers="choicedPlayers"
        v-show="stepThreeJoinCombatDetail"
        @success="stepThreeJoinCombatDetailSuccess"
        @lastStep="lastStep"/>
    </a-spin>
    <div class="btnContent" >
<!--      <div class="btn top20 right20" @click="lastStep()">上一步</div>-->
<!--      <div class="btn top20 left20" @click="nextStep()">查看报名数据</div>-->
    </div>
  </div>
</template>
<script>
import StepThreeCombat from './StepThreeCombat'
import StepThreeAlternativePlayer from './StepThreeAlternativePlayer'
import StepThreeJoinCombatDetail from './StepThreeJoinCombatDetail'
export default {
  components: {
    StepThreeCombat,
    StepThreeAlternativePlayer,
    StepThreeJoinCombatDetail
  },
  data () {
    return {
      playerLoading: false,
      stepThreeAlternativePlayerShow: true,
      stepThreeJoinCombatDetail: false,
      combatDetailGroup: null,
      matchId: this.$route.query.matchId,
      agencyId: this.$route.query.agencyId || null,
      playerData: {
        players: [],
        choicePlayerIds: []
      },
      // 预选队员列表
      choicedPlayers: []
    }
  },
  methods: {
    clickCombat (combatDetailGroup) {
      this.playerData = { players: [], choicePlayerIds: [] }
      if (combatDetailGroup != null) {
        this.queryAgencyPlayerByAge(combatDetailGroup)
      }
    },
    stepThreeAlternativePlayerOk (choicedPlayers) {
      this.choicedPlayers = choicedPlayers
      this.nextStep()
    },
    lastStep () {
      if (this.stepThreeAlternativePlayerShow && !this.stepThreeJoinCombatDetail) {
        this.$emit('lastStep')
      } else {
        this.stepThreeAlternativePlayerShow = true
        this.stepThreeJoinCombatDetail = false
      }
    },
    nextStep () {
      this.stepThreeAlternativePlayerShow = false
      this.stepThreeJoinCombatDetail = true
    },
    stepThreeJoinCombatDetailSuccess () {
      this.$emit('stepThreeJoinCombatDetailSuccess')
    },
    queryAgencyPlayerByAge (combatDetailGroup) {
      let params = {
        matchId: this.matchId,
        agencyId: this.agencyId,
        combatGroupName: combatDetailGroup.name,
        minAge: combatDetailGroup.minAge,
        maxAge: combatDetailGroup.maxAge
      }
      this.playerLoading = true
      this.$api.match.queryAgencyPlayerByAge(params).then(res => {
        if (res.status == 0) {
          this.$refs.stepThreeJoinCombatDetail.resetData()
          this.playerData = res.data
          if (this.playerData.players.length === 0) {
            this.$message.error('未查询到与组别年龄对应的队员信息')
          }
          if (this.playerData.choicePlayerIds.length > 0) {
            this.choicedPlayers = []
            this.playerData.players.forEach(item => {
              if (this.playerData.choicePlayerIds.indexOf(item.cardId) > -1) {
                let has = this.choicedPlayers.some(p => p.cardId === item.cardId)
                if (!has) {
                  this.choicedPlayers.push(item)
                }
              }
            })
            this.stepThreeAlternativePlayerShow = false
            this.stepThreeJoinCombatDetail = true
          } else {
            this.choicedPlayers = []
            this.stepThreeAlternativePlayerShow = true
            this.stepThreeJoinCombatDetail = false
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('获取队员信息失败')
      }).finally(_ => {
        this.playerLoading = false
        this.combatDetailGroup = combatDetailGroup
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .btnContent {
    text-align: center;
    .btn{
      color: #fff;
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      right: 250px;
      bottom: 29px;
      text-align: center;
      border-radius: 2px;
      background-color: #b80000;
      cursor:pointer;
      display: inline-block;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .top20 {
      margin-top: 20px;
    }
    .left20 {
      margin-left: 20px;
    }
    .right20 {
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/StepThree.vue